<div *ngIf="(isMobile$ | async) === false">
  <table mat-table [dataSource]="thermostats">
    <!-- Name Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Name</th>
      <td mat-cell *matCellDef="let element">
        <div class="flex flex-col gap-6">
          <div class="flex items-center gap-3">
            <a class="clickable">{{ element.name }}</a>
            <sbnb-cs-debug-item
              label="Thermostat ID"
              (click)="$event.stopPropagation()"
              [coreNovaLink]="'/dashboards/smartlocks?lock-id=' + element.id"
              [value]="element.id"
              linkLabel="Nova"></sbnb-cs-debug-item>
          </div>
        </div>
      </td>
    </ng-container>

    <!-- Humidity Column -->
    <ng-container matColumnDef="humidity">
      <th mat-header-cell *matHeaderCellDef>Humidity</th>
      <td mat-cell *matCellDef="let element">
        <div class="flex flex-col gap-6">{{ element.device_properties.humidity }}%</div>
      </td>
    </ng-container>

    <!-- Fan Column -->
    <ng-container matColumnDef="fan">
      <th mat-header-cell *matHeaderCellDef>Fan</th>
      <td mat-cell *matCellDef="let element">
        <div class="relative flex items-center pr-3">
          <sbnb-icon
            icon="mode-fan"
            [size]="22"
            [class]="element.device_properties.status.is_fan_running ? 'text-grass-darker' : 'text-smoke-darker'"
            [matTooltip]="
              'Fan is ' +
              (element.device_properties.status.is_fan_running
                ? element.device_properties.climate_setting.fan_mode
                : 'off')
            "></sbnb-icon>
          <span
            class="fan-status-badge"
            [class.fan-status-badge--active]="element.device_properties.status.is_fan_running">
            {{
              element.device_properties.status.is_fan_running
                ? element.device_properties.climate_setting.fan_mode
                : 'off'
            }}
          </span>
        </div>
      </td>
    </ng-container>

    <!-- Thermostat Setting Column -->
    <ng-container matColumnDef="thermostat-setting">
      <th mat-header-cell *matHeaderCellDef>Thermostat Setting</th>
      <td mat-cell *matCellDef="let element">
        <div class="flex items-center gap-3">
          <div
            class="flex items-center gap-2"
            *ngIf="
              element.device_properties.climate_setting.heating_point &&
              element.device_properties.climate_setting.heating_point.fahrenheit
            ">
            <sbnb-icon icon="matches-fire" class="text-coral"></sbnb-icon>
            {{ element.device_properties.climate_setting.heating_point.fahrenheit }}°F
          </div>

          <div
            class="flex items-center gap-2"
            *ngIf="
              element.device_properties.climate_setting.cooling_point &&
              element.device_properties.climate_setting.cooling_point.fahrenheit
            ">
            <sbnb-icon icon="temperature-snowflake" class="text-aqua"></sbnb-icon>
            {{ element.device_properties.climate_setting.cooling_point.fahrenheit }}°F
          </div>
        </div>
      </td>
    </ng-container>

    <!-- Current Temperature Column -->
    <ng-container matColumnDef="current-temperature">
      <th mat-header-cell *matHeaderCellDef>Current Temperature</th>
      <td mat-cell *matCellDef="let element">
        <div class="flex flex-col gap-6">{{ element.device_properties.temperature.fahrenheit }}°F</div>
      </td>
    </ng-container>

    <!-- Currently Active Preset Column -->
    <ng-container matColumnDef="current-pre-set">
      <th mat-header-cell *matHeaderCellDef>Current Pre-set</th>
      <td mat-cell *matCellDef="let element">
        <div class="flex flex-col gap-6 active-preset">
          {{ element.device_properties.climate_setting.display_name }}
        </div>
      </td>
    </ng-container>

    <!-- Online Column -->
    <ng-container matColumnDef="online">
      <th mat-header-cell *matHeaderCellDef>Online</th>
      <td mat-cell *matCellDef="let element">
        <div class="flex flex-col gap-6">
          <img
            *ngIf="element.device_properties.online"
            src="assets/iconography/online-antenna.svg"
            class="device-status-icon"
            alt="online" />
          <img
            *ngIf="!element.device_properties.online"
            src="assets/iconography/offline-antenna.svg"
            class="device-status-icon"
            alt="offline"
            [matTooltip]="element.issues | deviceIssuesTooltip" />

          <ng-container *ngIf="element.device_properties.keypad">
            <img
              *ngIf="element.device_properties.keypad.online"
              src="assets/iconography/online-antenna.svg"
              class="device-status-icon"
              alt="online" />
            <img
              *ngIf="!element.device_properties.keypad.online"
              src="assets/iconography/offline-antenna.svg"
              class="device-status-icon"
              alt="offline"
              [matTooltip]="element.issues | deviceIssuesTooltip" />
          </ng-container>
        </div>
      </td>
    </ng-container>

    <!-- Properties Column -->
    <ng-container matColumnDef="properties">
      <th mat-header-cell *matHeaderCellDef>Properties</th>
      <td mat-cell *matCellDef="let element">
        <div style="display: inline-block">
          <sbnb-avatar-group [items]="element.properties" [itemsForLabel]="element.name"></sbnb-avatar-group>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns"
      [class.double-height-row]="row.device_properties.keypad"
      (click)="nameClicked.emit({ deviceId: row.id, deviceType: row.device_type })"></tr>
  </table>
</div>

<div *ngIf="isMobile$ | async" class="mobile-devices-table">
  <mat-card *ngFor="let device of thermostats; trackBy: trackDevice">
    <mat-card-content (click)="nameClicked.emit({ deviceId: device.id, deviceType: device.device_type })">
      <div fxLayout="column" fxLayoutGap="12px">
        <div fxLayoutAlign="space-between center" fxLayoutGap="12px">
          <a class="strong ellipsis">{{ device.name }}</a>
          <div fxLayout fxLayoutAlign="start center" fxLayoutGap="12px">
            <img
              *ngIf="device.device_properties.online"
              src="assets/iconography/online-antenna.svg"
              class="device-status-icon"
              alt="online" />
            <img
              *ngIf="!device.device_properties.online"
              src="assets/iconography/offline-antenna.svg"
              class="device-status-icon"
              alt="offline"
              [matTooltip]="device.issues | deviceIssuesTooltip" />
          </div>
        </div>
      </div>

      <div style="display: inline-block">
        <sbnb-avatar-group [items]="device.properties" [itemsForLabel]="device.name"></sbnb-avatar-group>
      </div>
    </mat-card-content>
  </mat-card>
</div>
